module.exports = __webpack_public_path__ + "img/mengjunyang.91dfc28d.jpg";